<template>
  <div class="home">
    <div class="homeBox">
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="getData">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="resetSearch">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="8">
          <span class="label">按季度/月</span>
          <el-switch v-model="dateSwitch" @change="getQuarter"></el-switch>
        </el-col>
        <el-col :span="8">
          <span v-if="dateSwitch" class="label">选择月份</span>
          <span v-else class="label">选择季度</span>
          <el-date-picker v-if="dateSwitch" type="month" v-model="dateSelect" placeholder="选择月份">
          </el-date-picker>
          <el-select v-else v-model="dateSelect">
            <el-option :value="1" label="第一季度"></el-option>
            <el-option :value="2" label="第二季度"></el-option>
            <el-option :value="3" label="第三季度"></el-option>
            <el-option :value="4" label="第四季度"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="label">数据范围</span>
          <el-select multiple v-model="searchData.scopes" placeholder="数据范围" style="width: 300px">
            <el-option
              label="全部数据"
              value="all"
              @click.native="selectAll"
            />
            <el-option @click.native="selectSingle" v-for="item in dataRangeOptions" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="8">
          <span class="label">区域</span>
          <el-select class="area" v-model="searchData.region" placeholder="请选择" @change="changeRegion">
            <el-option v-for="item in areaList" :key="item.no" :label="item.name" :value="item.no">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="label">城&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市</span>
          <el-select class="area" v-model="searchData.city" placeholder="请选择" @change="changeCity">
            <el-option v-for="item in cityList" :key="item.no" :label="item.name" :value="item.no">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="label">门&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;店</span>
          <el-select class="area" v-model="searchData.door" placeholder="请选择" @change="changeDoor">
            <el-option v-for="item in doorList" :key="item.no" :label="item.name" :value="item.no">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="4">{{ reportName }}</el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple-light">
            <i class="el-icon-location-outline"></i>
            <span>{{ doorName }}</span>
          </div>
        </el-col>

        <el-col :span="4">
          <!--          <el-button type="success" size="mini">导出为EXCEL</el-button>-->
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <div class="chartBox">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card class="box-card">
              <div class="title">得分情况</div>
              <div class="score">
                <div>
                  <span class="curScore">{{ curScore }}</span>
                  <span class="icon upIcon" v-if="curScore > preScore">
                    <i class="el-icon-top"></i>
                  </span>
                  <span class="icon downIcon" v-if="curScore < preScore">
                    <i class="el-icon-bottom"></i>
                  </span>
                </div>
                <div v-if="dateSwitch">上月<span class="preScore">{{ preScore }}</span></div>
                <div v-else>上季度<span class="preScore">{{ preScore }}</span></div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card">
              <div class="title">得分趋势图</div>
              <div id="c1" class="c1"></div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card">
              <div class="title">大项得分分析</div>
              <div class="bigScore">
                <div class="col1" v-if="dateSwitch">
                  <p>本月</p>
                  <p>上月</p>
                </div>
                <div class="col1" v-else>
                  <p>本季</p>
                  <p>上季</p>
                </div>
                <div class="col2">
                  <div class="curData">{{ bigScore.type1[0] }}</div>
                  <div>
                    <div class="icon upIcon" v-if="bigScore.type1[0] > bigScore.type1[1]">
                      <i class="el-icon-top"></i>
                    </div>
                    <div class="icon downIcon" v-if="bigScore.type1[0] < bigScore.type1[1]">
                      <i class="el-icon-bottom"></i>
                    </div>
                  </div>
                  <div class="preData">{{ bigScore.type1[1] }}</div>
                  <div class="type">视觉陈列</div>
                </div>
                <div class="col3">
                  <div class="curData">{{ bigScore.type2[0] }}</div>
                  <div>
                    <div class="icon upIcon" v-if="bigScore.type2[0] > bigScore.type2[1]">
                      <i class="el-icon-top"></i>
                    </div>
                    <div class="icon downIcon" v-if="bigScore.type2[0] < bigScore.type2[1]">
                      <i class="el-icon-bottom"></i>
                    </div>
                  </div>
                  <div class="preData">{{ bigScore.type2[1] }}</div>
                  <div class="type">营运</div>
                </div>
                <div class="col4">
                  <div class="curData">{{ bigScore.type3[0] }}</div>
                  <div>
                    <div class="icon upIcon" v-if="bigScore.type3[0] > bigScore.type3[1]">
                      <i class="el-icon-top"></i>
                    </div>
                    <div class="icon downIcon" v-if="bigScore.type3[0] < bigScore.type3[1]">
                      <i class="el-icon-bottom"></i>
                    </div>
                  </div>
                  <div class="preData">{{ bigScore.type3[1] }}</div>
                  <div class="type">培训</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="12">
            <el-card class="box-card">
              <div class="title">评估者占比 <span class="badge">TTL {{ evaluationTotal }}</span></div>
              <div class="evaluation">
                <div class="leftPart">

                </div>
                <div id="c2" class="c2">

                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div class="title">行动完成情况 <span class="badge">TTL {{ activityTotal }}</span></div>
              <div class="evaluation">
                <div class="leftPart">

                </div>
                <div id="c3" class="c3">

                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-card class="box-card" style="margin-top: 20px">
          <div class="title">排名情况</div>
          <div class="rankBox">
            <div class="col">
              <div class="iconImg">
                <img src="../../static/images/rank1.png" alt="">
                <br/>
                <span>全国总排名</span>
              </div>
              <div class="rankData">
                <span class="label">{{ dateSwitch ? '本月' : '本季度' }}</span>
                <span class="cur">{{ rankData.country.curRank }}</span>
                <span class="curTotal">(of {{ rankData.country.curTotal }})</span>
              </div>
              <div class="rankData">
                <span class="label">{{ dateSwitch ? '上月' : '上季度' }}</span>
                <span class="pre">{{ rankData.country.preRank }}</span>
                <span class="preTotal">(of {{ rankData.country.preTotal }})</span>
              </div>
            </div>
            <div class="col">
              <div class="iconImg">
                <img src="../../static/images/rank2.png" alt="">
                <br/>
                <span>客户排名</span>
              </div>
              <div class="rankData">
                <span class="label">{{ dateSwitch ? '本月' : '本季度' }}</span>
                <span class="cur">{{ rankData.customer.curRank }}</span>
                <span class="curTotal">(of {{ rankData.customer.curTotal }})</span>
              </div>
              <div class="rankData">
                <span class="label">{{ dateSwitch ? '上月' : '上季度' }}</span>
                <span class="pre">{{ rankData.customer.preRank }}</span>
                <span class="preTotal">(of {{ rankData.customer.preTotal }})</span>
              </div>
            </div>
            <div class="col">
              <div class="iconImg">
                <img src="../../static/images/rank3.png" alt="">
                <br/>
                <span>区域排名</span>
              </div>
              <div class="rankData">
                <span class="label">{{ dateSwitch ? '本月' : '本季度' }}</span>
                <span class="cur">{{ rankData.area.curRank }}</span>
                <span class="curTotal">(of {{ rankData.area.curTotal }})</span>
              </div>
              <div class="rankData">
                <span class="label">{{ dateSwitch ? '上月' : '上季度' }}</span>
                <span class="pre">{{ rankData.area.preRank }}</span>
                <span class="preTotal">(of {{ rankData.area.preTotal }})</span>
              </div>
            </div>
            <div class="col">
              <div class="iconImg">
                <img src="../../static/images/rank4.png" alt="">
                <br/>
                <span>城市排名</span>
              </div>
              <div class="rankData">
                <span class="label">{{ dateSwitch ? '本月' : '本季度' }}</span>
                <span class="cur">{{ rankData.city.curRank }}</span>
                <span class="curTotal">(of {{ rankData.city.curTotal }})</span>
              </div>
              <div class="rankData">
                <span class="label">{{ dateSwitch ? '上月' : '上季度' }}</span>
                <span class="pre">{{ rankData.city.preRank }}</span>
                <span class="preTotal">(of {{ rankData.city.preTotal }})</span>
              </div>
            </div>
          </div>
        </el-card>
        <el-card class="box-card tableBox" style="margin-top: 20px">
          <div class="title">优势和机会点</div>
          <el-row :gutter="30" style="margin-top: 20px">
            <el-col :span="9">
              <template>
                <el-table :data="tableData1" style="width: 100%" :header-cell-style="tableHeadStyle">
                  <el-table-column prop="advantage" label="优势">
                  </el-table-column>
                  <el-table-column prop="curMonth" :label="dateSwitch ? '本月':'本季度'" width="70">
                    <template slot-scope="scope">
                      <span>{{ scope.row.curMonth }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="preMonth" :label="dateSwitch ? '上月':'上季度'" width="70">
                    <template slot-scope="scope">
                      <span>{{ scope.row.preMonth }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="↑/↓" width="40">
                    <template slot-scope="scope">
                      <span v-if="scope.row.preMonth < scope.row.curMonth">
                        <i class="el-icon-top up"></i>
                      </span>
                      <span v-if="scope.row.preMonth > scope.row.curMonth">
                        <i class="el-icon-bottom down"></i>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-col>
            <el-col :span="15">
              <template>
                <el-table :data="tableData2" style="width: 100%" :header-cell-style="tableHeadStyle">
                  <el-table-column prop="advantage" label="机会点" width="120">
                  </el-table-column>
                  <el-table-column prop="problem" label="问题">
                  </el-table-column>
                  <el-table-column prop="curMonth" :label="dateSwitch ? '本月':'本季度'" width="70">
                    <template slot-scope="scope">
                      <span>{{ scope.row.curMonth }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="preMonth" :label="dateSwitch ? '上月':'上季度'" width="70">
                    <template slot-scope="scope">
                      <span>{{ scope.row.preMonth }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="↑/↓"
                    width="40">
                    <template slot-scope="scope">
                      <span v-if="scope.row.preMonth < scope.row.curMonth">
                        <i class="el-icon-top up"></i>
                      </span>
                      <span v-if="scope.row.preMonth > scope.row.curMonth">
                        <i class="el-icon-bottom down"></i>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import {Chart} from '@antv/g2';
import _ from "lodash";

export default {
  name: "home",
  mounted() {
    // 获取当前季度/月份
    this.getQuarter()
    // 获取区域下拉框
    this.getOptions()
    // 获取数据范围选项
    this.getDataRangeOptions()
  },
  data() {
    return {
      dateSwitch: true,
      dateSelect: null,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
      filterData: {},
      initialFilterData: {
        region: null,
        city: null,
        door: null,
      },
      areaList: [],
      cityList: [],
      doorList: [],
      activeName: "first",
      reportName: "单店报告",
      doorName: "门店名称",
      resData: {},
      curScore: 0,
      preScore: 0,
      bigScore: {
        type1: [0, 0],
        type2: [0, 0],
        type3: [0, 0]
      }, // 大项得分分析数据,数据结构前后端修改都可以
      evaluationTotal: 0,
      activityTotal: 0,
      rankData: {
        country: {
          curRank: 0,
          curTotal: 0,
          preRank: 0,
          preTotal: 0
        },
        customer: {
          curRank: 0,
          curTotal: 0,
          preRank: 0,
          preTotal: 0
        },
        area: {
          curRank: 0,
          curTotal: 0,
          preRank: 0,
          preTotal: 0
        },
        city: {
          curRank: 0,
          curTotal: 0,
          preRank: 0,
          preTotal: 0
        },
      },// 排名情况数据, 数据结构前后端修改都可以
      tableData1: [],
      tableData2: [
        {
          advantage: "",
          problem: "",
          curMonth: 0,
          preMonth: 0
        }
      ],
      curMonthName: '本月',
      preMonthName: '上月',
      tableHeadStyle: {
        background: "#67C23A",
        color: "#fff"
      },
      searchData: {  //搜索条件
        city: "",
        door: null,
        mold: 1,  //1季度 2月
        region: "",
        type: 4,
        value: 3,
        year: 2021,
        scopes: [],
      },
      initScopes: ['all'],
      dataRangeOptions: [
      ]
    }
  },
  methods: {
    selectSingle() {
      _.remove(this.searchData.scopes, item => item === 'all');
      this.searchData.scopes = _.cloneDeep(this.searchData.scopes)
    },
    selectAll() {
      this.searchData.scopes = ['all']
    },
    async getDataRangeOptions() {
      let res = await axios.post(oprReqUrl+"/account/dataRoleList");
      if (res.data.code === 200) {
        this.dataRangeOptions = res.data.data
        this.searchData.scopes = this.initScopes
      }
    },
    resetSearch() {
      this.searchData.region = null
      this.searchData.city = null
      this.searchData.door = null
      this.searchData.scopes = this.initScopes
      this.getOptions()
    },
    getQuarter() {
      let date = new Date();
      let year = date.getFullYear();
      this.searchData.year = year
      let month = date.getMonth();
      if (this.dateSwitch) {
        this.dateSelect = new Date(year, month)
        return
      }
      if (month < 3) {
        this.dateSelect = 1
      } else if (month < 6) {
        this.dateSelect = 2
      } else if (month < 9) {
        this.dateSelect = 3
      } else if (month < 12) {
        this.dateSelect = 4
      }
    },
    changeFilter() {
      this.getOptions();
    },
    changeRegion() {
      this.searchData.city = null
      this.searchData.door = null
      for (const r of this.areaList) {
        if (r.no === this.searchData.region) {
          this.cityList = r.childs
        }
      }
    },
    changeCity() {
      this.searchData.door = null
      for (const r of this.areaList) {
        for (const c of r.childs) {
          if (c.no === this.searchData.city) {
            this.searchData.region = r.no
            this.cityList = r.childs
            this.doorList = c.childs
            return
          }
        }
      }
    },
    changeDoor() {
      for (const r of this.areaList) {
        for (const c of r.childs) {
          for (const d of c.childs) {
            if (d.no === this.searchData.door) {
              this.searchData.region = r.no
              this.searchData.city = c.no
              this.cityList = r.childs
              this.doorList = c.childs
              return
            }
          }
        }
      }
    },
    async getOptions() {
      const params = _.cloneDeep(this.searchData)
      _.forIn(params, (value, key) => {
        params[key] = params[key] ? [params[key]] : []
      });
      let res = await axios.post(oprReqUrl+"/door/linkagebyaccount", params);
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.areaList = dataList.region;
        this.cityList = dataList.city;
        this.doorList = dataList.door
      }
    },
    async getData() {
      _.remove(this.searchData.scopes, item => item === 'all');
      if (this.dateSelect == null) {
        this.$message.warning("请选择时间")
        return
      }
      if (this.searchData.door == null) {
        this.$message.warning("请选择门店")
        return
      }
      this.searchData.mold = this.dateSwitch ? 2 : 1
      if (this.searchData.mold == 2) {
        this.searchData.value = this.dateSelect.getMonth() + 1
        this.searchData.year = this.dateSelect.getFullYear()
      } else {
        this.searchData.value = this.dateSelect
      }

      let res = await axios.post(oprReqUrl+"/door/api/report", this.searchData);
      res = res.data
      if (res.code === 200) {
        this.resData = res.data

        this.reportName = res.data.reportName
        this.doorName = res.data.doorName

        // 得分情况
        this.scoreData();

        // 得分趋势图
        this.renderC1();

        //大项得分分析
        this.bigScoreData();

        // 评估者占比
        this.renderC2();

        // 行动完成情况
        this.renderC3();

        // 排名情况
        this.ranking();

        // 优势和机会点
        this.superiority();
      }
    },
    numberFormat(data) {
      if (typeof (data) == "undefined" || data == null) {
        data = 0
      }
      let res = (data * 1).toFixed(1) * 1
      return res
    },
    numberFormat2(data) {
      if (typeof (data) == "undefined" || data == null) {
        data = 0
      }
      return data;
    },
    numberPercentageFormat(data) {
      if (typeof (data) == "undefined" || data == null) {
        data = 0
      }
      let res = (data * 1 * 100).toFixed(1) * 1
      return res
    },
    // 得分情况
    scoreData() {
      let res = this.resData.score;
      this.curScore = this.numberPercentageFormat(res.now);
      this.preScore = this.numberPercentageFormat(res.previous);
    },
    // 渲染id为C1的图表
    renderC1() {
      let res = this.resData.trend.data;
      let trendData = []
      res.forEach((item) => {
        let row = {date: item.name, value: this.numberPercentageFormat(item.value)}
        trendData.unshift(row)
      })
      let data = trendData;

      if (this.chart1 != null) {
        this.chart1.data(data)
        this.chart1.render()
        return
      }
      const chart = new Chart({
        container: 'c1',
        autoFit: true,
        height: 200,
      });
      chart.data(data);
      chart.scale({
        date: {
          range: [0, 1],
        },
        value: {
          min: 0,
          max: 110,
          nice: true,
        },
      });

      chart.tooltip({
        showCrosshairs: false, // 是否展示 Tooltip 辅助线
        shared: true,
      });

      const geometry1 = chart.line().position('date*value').label('value');
      const geometry2 = chart.point().position('date*value');
      geometry1.color('#67C23A');
      geometry2.color('#67C23A');
      geometry1.label(
        'value',
        (val) => {
          return {
            content: val,
          };
        },
        {
          type: 'base', // 声明 label 类型
        }
      );

      chart.axis('value', false);
      // chart.render();
      this.chart1 = chart
      this.chart1.render()
    },
    // 大项得分分析
    bigScoreData() {
      //大项得分分析
      let res = this.resData.analyse;
      let nowVMS = this.numberPercentageFormat(res.nowVMS);
      let nowOPERATION = this.numberPercentageFormat(res.nowOPERATION);
      let nowTRAINING = this.numberPercentageFormat(res.nowTRAINING);

      let preVMS = this.numberPercentageFormat(res.preVMS);
      let preOPERATION = this.numberPercentageFormat(res.preOPERATION);
      let preTRAINING = this.numberPercentageFormat(res.preTRAINING);

      let type1 = [nowVMS, preVMS]
      let type2 = [nowOPERATION, preOPERATION]
      let type3 = [nowTRAINING, preTRAINING]
      let bigScoreData = {type1: type1, type2: type2, type3: type3}
      this.bigScore = bigScoreData
    },
    renderC2() {
      let total = this.resData.role.TTL * 1;
      this.evaluationTotal = total
      let roleData = this.resData.role.list;
      let roleDataTemp = [];
      roleData.forEach((item) => {
        let itemPercent = this.numberFormat(item.value / total)
        let row = {item: item.name, count: item.value, percent: itemPercent}
        roleDataTemp.push(row)
      })
      const data = roleDataTemp

      if (this.chart2 != null) {
        this.chart2.data(data)
        this.chart2.render()
        return
      }

      const chart = new Chart({
        container: 'c2',
        autoFit: true,
        height: 200,
      });

      chart.coordinate('theta', {
        radius: 0.75,
      });

      chart.data(data);

      chart.scale('percent', {
        formatter: (val) => {
          val = val * 100 + '%';
          return val;
        },
      });

      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });

      const geometry = chart
        .interval()
        .position('percent')
        .color('item')
        .label('percent', {
          content: (data) => {
            return `${data.item}: ${data.percent * 100}%`;
          },
        })
        .adjust('stack');

      geometry.label(false);
      geometry.color('item', ['#24e059', '#a7f3bd', '#66e98b', '#b3b3b3', '#333333', '#7f7f7f']);

      chart.interaction('element-active');

      // chart.render();
      this.chart2 = chart
      this.chart2.render()
    },
    renderC3() {
      let actionData = this.resData.action;
      let total = actionData.total;
      let noFinish = actionData.nofinish;
      let noPass = actionData.finishnopass;
      let pass = actionData.finishpass;
      let timeout = actionData.timeout;
      this.activityTotal = total;
      const data = [
        {item: '未完成 ' + noFinish, count: noFinish, percent: noFinish / total},
        {item: '已完成已通过 ' + pass, count: pass, percent: pass / total},
        {item: '已完成未通过 ' + noPass, count: noPass, percent: noPass / total},
        {item: '已超时 ' + timeout, count: timeout, percent: timeout / total},
      ];

      if (this.chart3 != null) {
        this.chart3.data(data)
        this.chart3.render()
        return
      }

      const chart = new Chart({
        container: 'c3',
        autoFit: true,
        height: 200,
      });

      chart.coordinate('theta', {
        radius: 0.75,
      });

      chart.data(data);

      chart.scale('percent', {
        formatter: (val) => {
          val = val * 100 + '%';
          return val;
        },
      });

      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });

      const geometry = chart
        .interval()
        .position('percent')
        .color('item')
        .label('percent', {
          content: (data) => {
            return `${data.item}: ${data.percent * 100}%`;
          },
        })
        .adjust('stack');

      geometry.label(false);
      geometry.color('item', ['#91efac', '#24e059', '#b3b3b3', '#333333']);

      chart.interaction('element-active');

      chart.render();

      this.chart3 = chart
      this.chart3.render()
    },
    // 排名情况
    ranking() {
      let rankingData = this.resData.ranking;
      this.rankData.country.curRank = this.numberFormat2(rankingData.countryNO);
      this.rankData.country.curTotal = this.numberFormat2(rankingData.countryCount);
      this.rankData.country.preRank = this.numberFormat2(rankingData.preCountryNO);
      this.rankData.country.preTotal = this.numberFormat2(rankingData.preCountryCount);

      this.rankData.customer.curRank = this.numberFormat2(rankingData.customerNO);
      this.rankData.customer.curTotal = this.numberFormat2(rankingData.customerCount);
      this.rankData.customer.preRank = this.numberFormat2(rankingData.preCustomerNO);
      this.rankData.customer.preTotal = this.numberFormat2(rankingData.preCustomerCount);

      this.rankData.area.curRank = this.numberFormat2(rankingData.regionNO);
      this.rankData.area.curTotal = this.numberFormat2(rankingData.regionCount);
      this.rankData.area.preRank = this.numberFormat2(rankingData.preRegionNO);
      this.rankData.area.preTotal = this.numberFormat2(rankingData.preRegionCount);

      this.rankData.city.curRank = this.numberFormat2(rankingData.cityNO);
      this.rankData.city.curTotal = this.numberFormat2(rankingData.cityCount);
      this.rankData.city.preRank = this.numberFormat2(rankingData.preCityNO);
      this.rankData.city.preTotal = this.numberFormat2(rankingData.preCityCount);
    },
    superiority() {
      // 优势
      let advantageData = this.resData.superiority.advantage;
      let advantageDataTemp = []
      advantageData.forEach((item) => {
        let row = {advantage: item.name, curMonth: this.numberPercentageFormat(item.d), preMonth: this.numberPercentageFormat(item.e)}
        advantageDataTemp.push(row)
      })
      this.tableData1 = advantageDataTemp

      // 机会点
      let chanceData = this.resData.superiority.chance;
      let chanceDataTemp = []
      chanceData.forEach((item) => {
        let row = {advantage: item.checkitem, problem: item.question, curMonth: this.numberPercentageFormat(item.d), preMonth: this.numberPercentageFormat(item.e)}
        chanceDataTemp.push(row)
      })
      this.tableData2 = chanceDataTemp
    }

  }
};
</script>

<style lang="sass" scoped>
.home
  width: 100%
  min-width: 1000px
  overflow: auto

.homeBox
  padding: 20px

  .filter
    margin-top: 30px
    padding: 0 20px

  .filterBar
    padding: 0 20px

  .label
    font-size: 14px
    color: #606266

  .infoBar
    height: 50px
    width: 100%
    background-color: #E6E6E6
    margin-top: 20px
    padding: 0 40px
    line-height: 50px
    box-sizing: border-box
    box-shadow: 0 2px 3px #D5D5D5

    .rightBtn
      float: right

  .chartBox
    margin: 20px

    .title
      font-size: 14px

      .badge
        float: right
        border: 1px solid #888
        border-radius: 4px
        line-height: 24px
        padding: 0 10px

    .icon
      color: #fff
      border-radius: 100%
      font-weight: 800
      display: inline-block

    .score
      text-align: center
      font-size: 14px
      height: 170px
      margin-top: 50px

      .icon
        height: 30px
        width: 30px
        line-height: 30px
        font-size: 22px
        vertical-align: 14px
        margin-left: 20px

    .curScore
      font-size: 48px
      font-weight: 500

    .preScore
      font-size: 28px
      color: #999
      margin-left: 20px

    .upIcon
      background: #67C23A

    .downIcon
      background: #808080

    .c1
      margin-top: 20px

    .bigScore
      height: 200px
      margin-top: 20px
      display: flex

      .col1
        width: 30px
        display: flex
        flex-direction: column
        font-size: 12px

        p
          height: 62px
          margin-top: 5px

      .col2, .col3, .col4
        width: calc(33% - 10px)
        display: flex
        flex-direction: column
        text-align: center

        .curData
          font-size: 20px
          font-weight: 500
          margin-bottom: 16px

        .preData
          font-size: 16px
          color: #999
          margin-top: 16px

        .type
          color: #999
          font-size: 14px
          margin-top: 16px

        .icon
          font-size: 14px
          width: 20px
          height: 20px
          line-height: 20px

      .col2, .col3
        border-right: 1px solid #dbdbdb

    .rankBox
      display: flex

      .col
        width: 25%
        align-items: center
        text-align: center
        border-right: 1px solid #ccc
        margin: 20px 0

        .iconImg
          img
            width: 60px
            height: 60px

          span
            font-size: 12px

        .rankData
          margin-top: 12px

          span.label
            font-size: 12px

          span
            font-size: 14px

          .cur, .pre
            font-size: 22px
            font-weight: 500
            margin-left: 16px
            margin-right: 16px

          .cur
            color: #67C23A

          .pre
            color: #999

          .preTotal
            color: #999

      .col:nth-last-child(1)
        border: 0

    .tableBox
      width: 100%

      .up
        color: #67C23A

      .down
        color: #999

</style>

<style lang="sass">
th.homeTableHead
  background: #67C23A
</style>



// WEBPACK FOOTER //
// src/opr/pages/views/HomeDoor.vue